import {
  getLocalizedAccountStatus,
  getLocalizedSorting,
  getLocalizedUserRoles,
} from '../translations/default'

export const UserFilter = {
  accessStatus: 'filter[status.equals]',
  createdDateGreaterEqual: 'filter[createdAt.gte]',
  createdDateLessEqual: 'filter[createdAt.lte]',
  customerContextId: 'filter[permissions.customerContextId.in]',
  customerName: 'filter[permissions.customerContext.customerName.icontains]',
  customerNumber:
    'filter[permissions.customerContext.customerNumber.icontains]',
  email: 'filter[email.icontains]',
  lastLoginDateGreaterEqual: 'filter[lastLoggedInAt.gte]',
  lastLoginDateLessEqual: 'filter[lastLoggedInAt.lte]',
  name: 'filter[name.icontains]',
  role: 'filter[permissions.role.equals]',
  salesGroupId: 'filter[permissions.salesGroupId.in]',
  searchQuery: 'search[query]',
  sort: 'sort',
}

export const userFilterTranslationMap = {
  accessStatus: getLocalizedAccountStatus,
  role: getLocalizedUserRoles,
  sort: getLocalizedSorting,
}

export const userFilterDefaults = {
  page: '1',
  sort: 'username',
}

export type UserFilters = typeof UserFilter
export type UserFilterKey = keyof UserFilters
export type UserFilterFnKey = keyof typeof userFilterTranslationMap
